/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetDepartmentCategoriesRequestBody = {
    properties: {
        categories: {
    type: 'array',
    contains: {
        type: 'DepartmentCategory',
    },
},
    },
};